import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.ReportsPage.ReportToolbar', {
    activateManualJournal:
        'To create accruals journals, you must be set up as a requester in the Manual Journal approval workflow.',
    createAccrualReportXeroText: 'Create accrual report for Xero...',
    createAccrualsJournal: 'Create accruals journal',
    discardChangesConfirmationNoText: 'Cancel',
    discardChangesConfirmationText: 'Discard report changes?',
    discardChangesConfirmationYesText: 'Discard',
    discardChangesText: 'Discard changes',
    downloadAttachmentArchiveText: 'Download the attachment archive for all requests',
    downloadAuditReportsText: 'Download audit reports archive for all requests',
    downloadAuditReportsTitle: `
        Download audit reports archive for all requests.
        An email with the link will be sent to you once archive is ready.`,
    editFilterText: 'Report setup',
    editFilterTitle: 'Change report filter',
    exportAsCsvTitle: 'Export as CSV file',
    hasFiltersPreviewText: 'This report shows requests that match the following filter:',
    invalidReportSaveError: 'Please fill in the report name.',
    noFilterPreviewText: 'This report shows all requests',
    otherActionsTitle: 'Other actions',
    printReportTitle: 'Print report',
    refreshReportDataTitle: 'Refresh report data',
    removeReportConfirmationNoText: 'Cancel',
    removeReportConfirmationText: 'Delete report?',
    removeReportConfirmationYesText: 'DELETE',
    removeReportText: 'Delete report',
    reportNameField: 'Report name',
    reportNamePlaceholder: 'Please enter report name',
    reportSchedulerTitle: 'Open report scheduler configuration',
    saveAsNewReportText: 'Save as new report',
    saveButtonText: 'Save',

    forceSaveDescription: `
        There are unsaved changes on the page.
        Please save the changes to proceed with the creation of the accruals journal.`,
    forceSaveButtonTextNo: 'Back',
    forceSaveButtonTextYes: 'Save changes',

    titleEditorLabel: 'Report name',
    titleEditorPlaceholder: 'Enter a name for the report',
    titleEditorSubmit: 'Save',
    titleEditorActivator: 'Edit',
});
